type Props = {
  className?: string;
};

const CloseIcon = (props: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00004 8.94267L11.7714 12.714C11.8971 12.8354 12.0655 12.9026 12.2403 12.9011C12.4151 12.8996 12.5823 12.8295 12.7059 12.7059C12.8295 12.5823 12.8996 12.4151 12.9012 12.2403C12.9027 12.0655 12.8355 11.8971 12.714 11.7713L8.94271 8L12.714 4.22867C12.8355 4.10293 12.9027 3.93453 12.9012 3.75974C12.8996 3.58494 12.8295 3.41773 12.7059 3.29412C12.5823 3.17052 12.4151 3.10041 12.2403 3.09889C12.0655 3.09737 11.8971 3.16456 11.7714 3.286L8.00004 7.05734L4.22871 3.286C4.10241 3.16757 3.93499 3.10291 3.76187 3.10572C3.58874 3.10854 3.42351 3.17859 3.30112 3.30107C3.17873 3.42354 3.10879 3.58883 3.1061 3.76195C3.10341 3.93507 3.16819 4.10245 3.28671 4.22867L7.05738 8L3.28604 11.7713C3.22237 11.8328 3.17158 11.9064 3.13664 11.9877C3.1017 12.0691 3.08331 12.1566 3.08254 12.2451C3.08178 12.3336 3.09864 12.4214 3.13216 12.5033C3.16568 12.5852 3.21519 12.6597 3.27778 12.7223C3.34038 12.7849 3.41481 12.8344 3.49674 12.8679C3.57867 12.9014 3.66646 12.9183 3.75498 12.9175C3.8435 12.9167 3.93098 12.8983 4.01231 12.8634C4.09365 12.8285 4.16721 12.7777 4.22871 12.714L8.00004 8.94267Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
